// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { MarginModes } from '@shared/utils/Enums/Constants';
import { MarginTypes } from '@shared/utils/Instruments/MarginTypes';
import { ProductType } from '@shared/utils/Instruments/ProductType';
import { RiskPlanSettings } from './RiskPlanSettings';
export class RiskSettings {
    constructor(instrument) {
        // TODO
        this.isShortable = true;
        this.RiskPlanSettings = new RiskPlanSettings();
        this.marginType = MarginTypes.MARGIN_PFS;
        this.marginMode = MarginModes.USE_PROFIT_LOSS;
        this.marginCoefficient = 1;
        this.instrument = instrument;
    }
    IsShortable(productType) {
        const riskPlanItem = this.getRiskPlanItem(productType || ProductType.General);
        if (!riskPlanItem) {
            return null;
        }
        return riskPlanItem.IsShortable;
    }
    isOvernightTradingsAllowed() {
        const riskPlanItem = this.getRiskPlanItem(ProductType.General);
        if (!riskPlanItem) {
            return null;
        }
        return riskPlanItem.AllowOvernightTrading;
    }
    IsPositionCloseOnly(productType, account) {
        const riskPlanItem = this.getRiskPlanItem(productType || ProductType.General, account);
        if (!riskPlanItem) {
            return null;
        }
        return riskPlanItem.IsPositionCloseOnly;
    }
    AllowWithdrawUnrealizedProfit(productType, account) {
        const riskPlanItem = this.getRiskPlanItem(productType || ProductType.General, account);
        if (!riskPlanItem) {
            return null;
        }
        return riskPlanItem.AllowToWithdrawUnrealizedProfit;
    }
    getLotStep(productType, account) {
        var _a;
        const riskPlanItem = this.getRiskPlanItem(productType, account);
        return (_a = riskPlanItem === null || riskPlanItem === void 0 ? void 0 : riskPlanItem.LotStep) !== null && _a !== void 0 ? _a : null;
    }
    IsCashTradingAllowed(productType, account) {
        var _a;
        const riskPlanItem = this.getRiskPlanItem(productType, account);
        return (_a = riskPlanItem === null || riskPlanItem === void 0 ? void 0 : riskPlanItem.IsCashTradingAllowed) !== null && _a !== void 0 ? _a : false;
    }
    getMaxLot(productType, account) {
        const riskPlanItem = this.getRiskPlanItem(productType, account);
        return riskPlanItem && riskPlanItem.MaxLot !== null ? riskPlanItem.MaxLot : this.maxLot;
    }
    getMinLot(productType, account) {
        const riskPlanItem = this.getRiskPlanItem(productType, account);
        return riskPlanItem && riskPlanItem.MinLot !== null ? riskPlanItem.MinLot : this.minLot;
    }
    getMaxPositionValue(productType, account) {
        var _a;
        const riskPlanItem = this.getRiskPlanItem(productType, account);
        return (_a = riskPlanItem === null || riskPlanItem === void 0 ? void 0 : riskPlanItem.MaxPositionValuePerSymbol) !== null && _a !== void 0 ? _a : null;
    }
    getPositionValueCurrencyId(productType, account) {
        var _a;
        const riskPlanItem = this.getRiskPlanItem(productType, account);
        return (_a = riskPlanItem === null || riskPlanItem === void 0 ? void 0 : riskPlanItem.PositionValueCurrencyId) !== null && _a !== void 0 ? _a : null;
    }
    getRiskPlanItem(productType, account = null) {
        const riskPlanSettings = (account === null || account === void 0 ? void 0 : account.RiskPlan)
            ? account.RiskPlan.riskPlanCache.getRiskPlanSettings(this.instrument, productType)
            : this.RiskPlanSettings;
        return riskPlanSettings ? riskPlanSettings.get(productType) : null;
    }
    /// /#region Misc
    Update(im) {
        if (im == null) {
            return;
        }
        if (im.CalculateMarginType !== null && im.CalculateMarginType !== undefined) {
            this.marginType = im.CalculateMarginType;
        }
        if (im.MarginMode !== null && im.MarginMode !== undefined) {
            this.marginMode = im.MarginMode;
        }
        if (im.UseSameCrossPriceForOpenClose !== null && im.UseSameCrossPriceForOpenClose !== undefined) {
            this.useSameCrossPriceForOpenClose = im.UseSameCrossPriceForOpenClose;
        }
        if (im.HedgedMarginCallSize !== null && im.HedgedMarginCallSize !== undefined) {
            this.hedgedMarginCallSize = im.HedgedMarginCallSize;
        }
        if (im.UseOvernightMargin !== null && im.UseOvernightMargin !== undefined) {
            this.useOvernightMargin = im.UseOvernightMargin;
        }
        if (im.AllowOvernightTrading !== null && im.AllowOvernightTrading !== undefined) {
            this.allowOvernightTrading = im.AllowOvernightTrading;
        }
        if (im.AllowToWithdrawUnrealizedProfit !== null && im.AllowToWithdrawUnrealizedProfit !== undefined) {
            this.AllowToWithdrawUnrealizedProfit = im.AllowToWithdrawUnrealizedProfit;
        }
        if (im.UseLongShortMargin !== null && im.UseLongShortMargin !== undefined) {
            this.useLongShortMargin = im.UseLongShortMargin;
        }
        if (im.MarginCoefficient !== null && im.MarginCoefficient !== undefined) {
            this.marginCoefficient = im.MarginCoefficient;
        }
        if (im.UseOpenPriceInMargin !== null && im.UseOpenPriceInMargin !== undefined) {
            this.useOpenPriceInMargin = im.UseOpenPriceInMargin;
        }
        if (im.IsShortable !== null && im.IsShortable !== undefined) {
            this.isShortable = im.IsShortable;
        }
        if (im.MaxLot !== null && im.MaxLot !== undefined) {
            this.maxLot = im.MaxLot;
        }
        if (im.MinimalLot !== null && im.MinimalLot !== undefined) {
            this.minLot = im.MinimalLot;
        }
    }
    UseSameCrossPriceForOpenClose(productType) {
        return (!!this.RiskPlanSettings.cache[productType] &&
            this.RiskPlanSettings.cache[productType].UseSameCrossPriceForOpenClose);
    }
}
